<template>
  <div id="modalAvaliationEvento" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Avaliar Evento</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">
            <!-- Dados do Evento -->
            <div class="card border border-width-2 border-teal">
              <div class="card-header d-flex align-items-center p-2">
                <p class="mb-0">Dados do Evento</p>
                <div class="ms-auto">
                  <p class="fs-sm mb-0">
                    <span>
                      {{
                        createdUpdatedUser(
                          evento.usuarioCriacao,
                          evento.dataCriacao,
                          'created',
                        )
                      }}
                    </span>
                    <span v-if="evento.usuarioAlteracao" class="px-1">|</span>
                    <span v-if="evento.usuarioAlteracao">
                      {{
                        createdUpdatedUser(
                          evento.usuarioAlteracao,
                          evento.dataAlteracao,
                          'updated',
                        )
                      }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="card-body">
                <div class="row g-2">
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Demandante (Gestor)</p>
                    <p class="fw-semibold mb-0">{{ evento.demandante }}</p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Entidade Demandante</p>
                    <p class="fw-semibold mb-0">
                      {{ evento.entidadeDemandante }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">
                      Nome do evento, patrocínio ou projeto
                    </p>
                    <p class="fw-semibold mb-0">{{ evento.nome }}</p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Data</p>
                    <p class="fw-semibold mb-0">
                      {{ dateTimeSqlToDateBR(evento.dataInicial) }} -
                      {{ dateTimeSqlToDateBR(evento.dataFinal) }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">
                      Local de realização - Cidade/Estado
                    </p>
                    <p class="fw-semibold mb-0">
                      {{ evento.local }} - {{ evento.cidade }}/{{
                        evento.estado
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Público</p>
                    <p class="fw-semibold mb-0">
                      {{ formatWithDot(evento.publico) }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Observações</p>
                    <p class="fw-semibold mb-0">
                      {{ evento.observacao ?? '-' }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">
                      Custo Total Cadastrado
                      <span v-if="evento.custoTotalAprovado !== null">
                        / Custo Total Aprovado
                      </span>
                    </p>
                    <p class="fw-semibold mb-0">
                      {{ moneyToCurrencyBr(evento.custoTotal) }}
                      <span v-if="evento.custoTotalAprovado !== null">
                        / {{ moneyToCurrencyBr(evento.custoTotalAprovado) }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Dados das Entidades -->
            <p class="mb-3">Entidades:</p>
            <div
              class="card border border-width-2 border-teal"
              v-for="(entidade, index) in evento.entidades"
              :key="index"
            >
              <div class="card-header d-flex align-items-center p-2">
                <p class="mb-0">
                  Status atual:
                  <span
                    v-html="statusEventosTranslate(entidade.status, 'label')"
                  />
                </p>
                <span
                  v-if="entidade.principal == entidadesEventos.PRINCIPAL"
                  class="badge bg-primary ms-1"
                >
                  Principal
                </span>
                <div class="ms-auto">
                  <p class="fs-sm mb-0">
                    <span>
                      {{
                        createdUpdatedUser(
                          entidade.usuarioCriacao,
                          entidade.dataCriacao,
                          'created',
                        )
                      }}
                    </span>
                    <span v-if="entidade.usuarioAlteracao" class="px-1">|</span>
                    <span v-if="entidade.usuarioAlteracao">
                      {{
                        createdUpdatedUser(
                          entidade.usuarioAlteracao,
                          entidade.dataAlteracao,
                          'updated',
                        )
                      }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="card-body">
                <div class="row g-2">
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Nome</p>
                    <p class="fw-semibold mb-0">{{ entidade.nome }}</p>
                  </div>
                  <div
                    v-if="entidade.status != statusEventos.AGUARDANDO_APROVACAO"
                    class="col-md-3"
                  >
                    <p class="text-muted mb-1">Classificação</p>
                    <p class="fw-semibold mb-0">
                      {{ entidade.classificacao ?? '-' }}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <p class="text-muted mb-1">Custo Cadastrado</p>
                    <p class="fw-semibold mb-0">
                      {{ moneyToCurrencyBr(entidade.custo) }}
                    </p>
                  </div>
                  <div v-if="entidade.codColigada !== null" class="col-md-6">
                    <p class="text-muted mb-1">Centro de Custo (Agrupador)</p>
                    <p class="fw-semibold mb-0">
                      {{ entidade.codCCustoPai || '-' }}
                      {{
                        entidade.nomeCCustoPai
                          ? `- ${entidade.nomeCCustoPai}`
                          : ''
                      }}
                    </p>
                  </div>
                  <template
                    v-if="
                      entidade.codColigada !== null &&
                      entidade.status != statusEventos.AGUARDANDO_APROVACAO
                    "
                  >
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Centro de Custo (Detalhado)</p>
                      <p class="fw-semibold mb-0">
                        {{ entidade.codCCustoFilho || '-' }}
                        {{
                          entidade.nomeCCustoFilho
                            ? `- ${entidade.nomeCCustoFilho}`
                            : ''
                        }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Natureza Orçamentária</p>
                      <p class="fw-semibold mb-0">
                        {{ entidade.codTBOrcamento || '-' }}
                        {{
                          entidade.nomeTBOrcamento
                            ? `- ${entidade.nomeTBOrcamento}`
                            : ''
                        }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Mês</p>
                      <p class="fw-semibold mb-0">
                        {{ nomeMes(entidade.mes) }}
                      </p>
                    </div>
                  </template>
                  <div v-if="entidade.observacao" class="col-md-12">
                    <p class="text-muted mb-1">Observações</p>
                    <p class="fw-semibold mb-0">{{ entidade.observacao }}</p>
                  </div>
                </div>
                <template v-if="podeAvaliar(entidade)">
                  <hr class="my-2" />
                  <div class="row g-2 align-items-end">
                    <div class="col-lg-4">
                      <label class="form-label">
                        Avaliação: <span class="text-danger">*</span>
                      </label>
                      <div class="d-flex gap-2">
                        <button
                          type="button"
                          :class="[
                            'btn btn-sm flex-fill',
                            avaliacoes[index].status === statusEventos.REPROVADO
                              ? 'btn-danger'
                              : 'btn-outline-danger',
                          ]"
                          title="Reprovado"
                          @click="setAvaliacao(index, statusEventos.REPROVADO)"
                        >
                          <i class="ph-x me-1" /> Reprovado
                        </button>
                        <button
                          v-if="evento.periodo == periodoAtivo.PROPOSTA"
                          type="button"
                          :class="[
                            'btn btn-sm flex-fill',
                            avaliacoes[index].status ===
                            statusEventos.REFORMULADO
                              ? 'btn-info'
                              : 'btn-outline-info',
                          ]"
                          title="Reformulado"
                          @click="
                            setAvaliacao(index, statusEventos.REFORMULADO)
                          "
                        >
                          <i class="ph-arrow-counter-clockwise me-1" />
                          Reformulado
                        </button>
                        <button
                          type="button"
                          :class="[
                            'btn btn-sm flex-fill',
                            avaliacoes[index].status === statusEventos.APROVADO
                              ? 'btn-success'
                              : 'btn-outline-success',
                          ]"
                          title="Aprovado"
                          @click="setAvaliacao(index, statusEventos.APROVADO)"
                        >
                          <i class="ph-check me-1" /> Aprovado
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <label class="form-label">
                        Classificação: <span class="text-danger">*</span>
                      </label>
                      <select
                        class="form-control form-control-sm"
                        :class="{
                          'is-invalid':
                            (avaliacoes[index].status ===
                              statusEventos.REPROVADO ||
                              avaliacoes[index].status ===
                                statusEventos.APROVADO ||
                              avaliacoes[index].status ===
                                statusEventos.REFORMULADO) &&
                            !avaliacoes[index].classificacao,
                        }"
                        v-model="avaliacoes[index].classificacao"
                      >
                        <option value="">Selecione uma opção</option>
                        <option value="Evento">Evento</option>
                        <option value="Patrocínio">Patrocínio</option>
                      </select>
                    </div>
                    <template v-if="entidade.codColigada !== null">
                      <div class="col-lg-4">
                        <label class="form-label">
                          Centro de Custo (Agrupador):
                          <span class="text-danger">*</span>
                        </label>
                        <select
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid':
                              (avaliacoes[index].status ===
                                statusEventos.REPROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.APROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.REFORMULADO) &&
                              !avaliacoes[index].codCCustoPai,
                          }"
                          v-model="avaliacoes[index].codCCustoPai"
                          @change="getCentrosCustosFilhos(index)"
                        >
                          <option value="">Selecione uma opção</option>
                          <option
                            v-for="cc in centrosCustoPaisDisponiveis(entidade)"
                            :key="cc.codCCustoPai"
                            :value="cc.codCCustoPai"
                          >
                            {{ cc.codCCustoPai }} - {{ cc.nomeCCustoPai }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <label class="form-label">
                          Centro de Custo (Detalhado):
                          <span class="text-danger">*</span>
                        </label>
                        <select
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid':
                              (avaliacoes[index].status ===
                                statusEventos.REPROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.APROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.REFORMULADO) &&
                              !avaliacoes[index].codCCustoFilho,
                          }"
                          v-model="avaliacoes[index].codCCustoFilho"
                          :disabled="!avaliacoes[index].codCCustoPai"
                          @change="getNaturezasOrcamentarias(index)"
                        >
                          <option value="">Selecione uma opção</option>
                          <option
                            v-for="filho in centrosCustosFilhos[index]"
                            :key="filho.codCCustoFilho"
                            :value="filho.codCCustoFilho"
                          >
                            {{ filho.codCCustoFilho }} -
                            {{ filho.nomeCCustoFilho }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <label class="form-label">
                          Natureza Orçamentária:
                          <span class="text-danger">*</span>
                        </label>
                        <select
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid':
                              (avaliacoes[index].status ===
                                statusEventos.REPROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.APROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.REFORMULADO) &&
                              !avaliacoes[index].codTBOrcamento,
                          }"
                          v-model="avaliacoes[index].codTBOrcamento"
                          :disabled="!avaliacoes[index].codCCustoFilho"
                        >
                          <option value="">Selecione uma opção</option>
                          <option
                            v-for="natureza in naturezasOrcamentarias[index]"
                            :key="natureza.codTBOrcamento"
                            :value="natureza.codTBOrcamento"
                          >
                            {{ natureza.codTBOrcamento }} - {{ natureza.nome }}
                            <span
                              v-if="natureza.inativo == '1'"
                              class="text-danger"
                            >
                              (INATIVA)
                            </span>
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-2">
                        <label class="form-label">
                          Mês: <span class="text-danger">*</span>
                        </label>
                        <select
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid':
                              (avaliacoes[index].status ===
                                statusEventos.REPROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.APROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.REFORMULADO) &&
                              !avaliacoes[index].mes,
                          }"
                          v-model="avaliacoes[index].mes"
                        >
                          <option value="">Selecione uma opção</option>
                          <option
                            v-for="mes in mesesDisponiveis"
                            :key="mes.valor"
                            :value="mes.valor"
                          >
                            {{ mes.nome }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-2">
                        <label class="form-label">
                          Custo Aprovado: <span class="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid':
                              (avaliacoes[index].status ===
                                statusEventos.REPROVADO ||
                                avaliacoes[index].status ===
                                  statusEventos.APROVADO) &&
                              (avaliacoes[index].custoAprovado === null ||
                                avaliacoes[index].custoAprovado === '' ||
                                Number(avaliacoes[index].custoAprovado) < 0),
                          }"
                          v-model.number="avaliacoes[index].custoAprovado"
                          min="0"
                        />
                      </div>
                    </template>
                    <div class="col-md-12">
                      <label class="form-label">
                        Observações:
                        <span
                          v-if="
                            avaliacoes[index].status ===
                              statusEventos.REPROVADO ||
                            avaliacoes[index].status ===
                              statusEventos.REFORMULADO
                          "
                          class="text-danger"
                        >
                          *
                        </span>
                      </label>
                      <textarea
                        class="form-control"
                        :class="{
                          'is-invalid':
                            (avaliacoes[index].status ===
                              statusEventos.REPROVADO ||
                              avaliacoes[index].status ===
                                statusEventos.REFORMULADO) &&
                            !avaliacoes[index].observacao?.trim(),
                        }"
                        placeholder="Observações"
                        rows="2"
                        v-model="avaliacoes[index].observacao"
                      />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    v-if="entidade.status == statusEventos.AGUARDANDO_APROVACAO"
                  >
                    <hr class="my-2" />
                    <p class="text-muted mb-0">
                      <i class="ph-lock me-1" /> Avaliação não permitida para
                      esta entidade
                    </p>
                  </div>
                </template>
              </div>
              <div class="card-footer p-0">
                <a
                  :href="'#collapsible-historio-entidade-' + index"
                  data-bs-toggle="collapse"
                  class="collapsed link-success"
                  aria-expanded="false"
                  title="Histórico"
                >
                  <div class="card-header d-flex align-items-center p-2">
                    <p class="mb-0">
                      <i class="ph-caret-down collapsible-indicator me-1" />
                      Histórico
                    </p>
                  </div>
                </a>
                <div
                  :id="'collapsible-historio-entidade-' + index"
                  class="border-top collapse"
                >
                  <div class="card-body">
                    <div class="d-flex align-items-stretch gap-2">
                      <div
                        v-for="(historico, hIndex) in entidade.historico"
                        :key="historico.id"
                        class="d-flex align-items-center gap-2"
                      >
                        <div
                          class="d-flex flex-column align-items-center h-100 gap-2 border rounded p-2"
                        >
                          <span
                            v-html="
                              statusEventosTranslate(historico.status, 'label')
                            "
                          />
                          <span class="fw-semibold fs-sm">
                            {{ historico.usuario }} ·
                            {{ dateTimeSqlToDateTimeBR(historico.data) }}
                          </span>
                          <span
                            v-if="historico.observacao"
                            class="text-muted fs-sm"
                          >
                            {{ historico.observacao }}
                          </span>
                        </div>
                        <i
                          v-if="hIndex < entidade.historico.length - 1"
                          class="ph-arrow-right text-muted"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              title="Confirmar Avaliação"
              :disabled="!todasAvaliadas || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dateTimeSqlToDateTimeBR, dateTimeSqlToDateBR } from '@/utils/date'
import {
  createdUpdatedUser,
  moneyToCurrencyBr,
  formatWithDot,
  statusEventosTranslate,
} from '@/utils/strings'
import { showModal, hideModal } from '@/utils/modal'
import StatusEventoEnum from '@/enum/statusEventoEnum'
import PeriodoAtivoEnum from '@/enum/periodoAtivoEnum'
import EntidadeEventoEnum from '@/enum/entidadeEventoEnum'

export default {
  name: 'AvaliationEventoModal',

  props: {
    eventoId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      empresas: [],
      centrosCustosFilhos: [],
      naturezasOrcamentarias: [],
      evento: {},
      avaliacoes: [],
      meses: [
        { valor: 1, nome: 'Janeiro' },
        { valor: 2, nome: 'Fevereiro' },
        { valor: 3, nome: 'Março' },
        { valor: 4, nome: 'Abril' },
        { valor: 5, nome: 'Maio' },
        { valor: 6, nome: 'Junho' },
        { valor: 7, nome: 'Julho' },
        { valor: 8, nome: 'Agosto' },
        { valor: 9, nome: 'Setembro' },
        { valor: 10, nome: 'Outubro' },
        { valor: 11, nome: 'Novembro' },
        { valor: 12, nome: 'Dezembro' },
      ],
      disableButton: false,
      dateTimeSqlToDateTimeBR,
      dateTimeSqlToDateBR,
      createdUpdatedUser,
      moneyToCurrencyBr,
      formatWithDot,
      statusEventosTranslate,
    }
  },

  computed: {
    ...mapGetters(['user']),

    statusEventos() {
      return StatusEventoEnum
    },

    periodoAtivo() {
      return PeriodoAtivoEnum
    },

    entidadesEventos() {
      return EntidadeEventoEnum
    },

    mesesDisponiveis() {
      if (Number(this.evento.periodo) === this.periodoAtivo.REFORMULACAO) {
        return this.meses.filter((mes) => mes.valor >= 7)
      }

      return this.meses
    },

    custoTotalAprovado() {
      return this.avaliacoes.reduce((total, avaliacao) => {
        return total + (Number(avaliacao.custoAprovado) || 0)
      }, 0)
    },

    todasAvaliadas() {
      if (!this.avaliacoes.length) {
        return false
      }

      return this.evento.entidades.every((entidade, index) => {
        if (!this.podeAvaliar(entidade)) {
          return true
        }

        const avaliacao = this.avaliacoes[index]
        if (avaliacao.status === null) {
          return false
        }

        if (!avaliacao.classificacao) {
          return false
        }

        if (entidade.codColigada !== null) {
          if (
            !avaliacao.codCCustoPai ||
            !avaliacao.codCCustoFilho ||
            !avaliacao.codTBOrcamento ||
            !avaliacao.mes
          ) {
            return false
          }
        }

        const exigeCustoAprovado =
          ((avaliacao.status === this.statusEventos.REPROVADO ||
            avaliacao.status === this.statusEventos.APROVADO) &&
            avaliacao.custoAprovado === null) ||
          avaliacao.custoAprovado === '' ||
          Number(avaliacao.custoAprovado) < 0

        if (exigeCustoAprovado) {
          return false
        }

        const exigeObservacao =
          (avaliacao.status === this.statusEventos.REPROVADO ||
            avaliacao.status === this.statusEventos.REFORMULADO) &&
          !avaliacao.observacao?.trim()

        if (exigeObservacao) {
          return false
        }

        return true
      })
    },
  },

  methods: {
    async getEmpresas() {
      try {
        this.empresas = await this.$store.dispatch('getEmpresas', {
          cCustoPai: true,
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getEvento() {
      try {
        this.evento = await this.$store.dispatch('getEvento', this.eventoId)

        this.avaliacoes = this.evento.entidades.map((entidade) => ({
          entidadeId: entidade.id,
          codColigada: entidade.codColigada || null,
          classificacao: entidade.classificacao || '',
          custoAprovado: entidade.custoAprovado ?? entidade.custo,
          codCCustoPai: entidade.codCCustoPai || '',
          codCCustoFilho: entidade.codCCustoFilho || '',
          codTBOrcamento: entidade.codTBOrcamento || '',
          mes: entidade.mes || '',
          status: null,
          observacao: '',
        }))

        this.centrosCustosFilhos = this.evento.entidades.map(() => [])
        this.naturezasOrcamentarias = this.evento.entidades.map(() => [])

        showModal('modalAvaliationEvento')

        await Promise.all(
          this.avaliacoes.map((avaliacao, index) => {
            if (
              Number(this.user.codColigada) === Number(avaliacao.codColigada) &&
              avaliacao.codCCustoPai
            ) {
              return this.getCentrosCustosFilhos(index, false)
            }

            return Promise.resolve()
          }),
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    centrosCustoPaisDisponiveis(entidade) {
      if (!entidade.codColigada) {
        return []
      }

      const empresa = this.empresas.find(
        (e) => Number(e.codColigada) === Number(entidade.codColigada),
      )
      return empresa ? empresa.ccCustos : []
    },

    async getCentrosCustosFilhos(index, limparValores = true) {
      if (this.avaliacoes[index].codCCustoPai === '') {
        this.avaliacoes[index].codCCustoFilho = ''
        this.avaliacoes[index].codTBOrcamento = ''
        this.centrosCustosFilhos.splice(index, 1, [])
        return
      }

      try {
        const centrosCustosFilhos = await this.$store.dispatch(
          'getCentrosCustosFilhos',
          this.avaliacoes[index].codCCustoPai,
        )

        this.centrosCustosFilhos.splice(index, 1, centrosCustosFilhos)

        if (limparValores) {
          this.avaliacoes[index].codCCustoFilho = ''
          this.avaliacoes[index].codTBOrcamento = ''
          this.naturezasOrcamentarias.splice(index, 1, [])
          return
        }

        if (this.avaliacoes[index].codCCustoFilho) {
          await this.getNaturezasOrcamentarias(index, false)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getNaturezasOrcamentarias(index, limparValor = true) {
      if (this.avaliacoes[index].codCCustoFilho === '') {
        this.avaliacoes[index].codTBOrcamento = ''
        this.naturezasOrcamentarias.splice(index, 1, [])
        return
      }

      try {
        const naturezasOrcamentarias = await this.$store.dispatch(
          'getNaturezasOrcamentarias',
          {
            codCCustoPai: this.avaliacoes[index].codCCustoPai,
            codCCustoFilho: this.avaliacoes[index].codCCustoFilho,
          },
        )

        this.naturezasOrcamentarias.splice(index, 1, naturezasOrcamentarias)

        if (limparValor) {
          this.avaliacoes[index].codTBOrcamento = ''
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    podeAvaliar(entidade) {
      const statusEntidade = Number(entidade.status)
      const statusEvento = Number(this.evento.status)
      const codColigadaEntidade = Number(entidade.codColigada)
      const codColigadaUsuario = Number(this.user.codColigada)

      const statusValido =
        statusEntidade === this.statusEventos.AGUARDANDO_APROVACAO ||
        statusEntidade === this.statusEventos.APROVADO ||
        statusEntidade === this.statusEventos.REPROVADO ||
        (statusEvento === this.statusEventos.REFORMULADO &&
          statusEntidade === this.statusEventos.REFORMULADO)

      const coligadaValida =
        entidade.codColigada === null ||
        codColigadaEntidade === codColigadaUsuario

      return statusValido && coligadaValida
    },

    setAvaliacao(index, status) {
      this.avaliacoes[index].status = status
    },

    nomeMes(numero) {
      const mes = this.meses.find((m) => m.valor === Number(numero))
      return mes ? mes.nome : '-'
    },

    async save() {
      if (!this.todasAvaliadas) return

      this.disableButton = true
      try {
        const response = await this.$store.dispatch('avaliationEvento', {
          eventoId: this.eventoId,
          custoTotalAprovado: this.custoTotalAprovado,
          avaliacoes: this.avaliacoes.filter((a) => a.status !== null),
        })

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getEmpresas()
    this.getEvento()
  },
}
</script>
